import React, { memo } from "react";
import * as PropTypes from "prop-types";

import {
  BioTitle,
  MobileSectionForRender,
  P,
  StyledDivider,
} from "../../container/index.styled";

const Specialities = ({ translations, specialities = [] }) => (
  <>
    <StyledDivider />
    <MobileSectionForRender>
      <BioTitle>{translations.specialties}</BioTitle>
      {specialities?.map((item) => {
        const {
          attributes: { name },
        } = item;
        return <P key={item.id}>{name}</P>;
      })}
    </MobileSectionForRender>
  </>
);

Specialities.propTypes = {
  translations: PropTypes.object,
  specialities: PropTypes.array,
};

export default memo(Specialities);
